import { createState, asFilteredSubscribable, asNonNullSubscribable } from '../helpers/state-subject';
import Scroll from './Scroll';
const NO_COMPONENT = null;
const overlayEl = document.getElementById("js-overlay");
const overlayState = createState(NO_COMPONENT);
export const whenOverlayShown = asNonNullSubscribable(overlayState);
export function whenNotShownInOverlay(component) {
    return asFilteredSubscribable(overlayState, (state) => state !== component);
}
if (overlayEl) {
    overlayEl.addEventListener('click', () => {
        hideOverlay();
    });
    overlayState.subscribe((state) => {
        console.log("overlay state", state);
        if (state === NO_COMPONENT) {
            overlayEl.classList.remove('is-active');
            Scroll.unlock();
        }
        else {
            overlayEl.classList.add('is-active');
            Scroll.lock();
        }
    });
}
export function hideOverlay() {
    if (overlayState.get() !== NO_COMPONENT) {
        overlayState.set(NO_COMPONENT);
    }
}
export function showOverlay(content) {
    overlayState.set(content);
}
export function isOverlayShown() {
    return overlayState.get() !== NO_COMPONENT;
}
